export default __webpack_public_path__ + "static/media/vol6_3.d0aeee2d.png";